import { AxiosResponse } from "axios";
import BaseApi from "./BaseApi";
import AxiosService from "./Axios";

const BASE_URL = '/tenant-user';

class TenantUserApi {
    
    public async generateTenantAdminAuthorization(tenantId: string): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/login-tenant-admin?tenantId=${tenantId}`);
    }

    public async getTenantUserViews(tenantId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/user-views', {
            params: { tenantId: tenantId}
        });
    }

    public async getTenantUserView(tenantId: string, userId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/user-view', {
            params: { tenantId: tenantId, userId: userId }
        });
    }

    public async getTenantUsers(tenantId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/users', {
            params: { tenantId: tenantId}
        });
    }

    public async getTenantUser(tenantId: string, userId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/user', {
            params: { tenantId: tenantId, userId: userId }
        });
    }

    public async createTenantUser(tenantId: string, user: any): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/create-user?tenantId=${tenantId}`, user);
    }

    public async updateTenantUser(tenantId: string, user: any): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/update-user?tenantId=${tenantId}`, user);
    }

    public async deleteTenantUser(tenantId: string, userId: string): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/delete-user?tenantId=${tenantId}`, {
            userId: userId
        });
    }

    public async getTenantRoles(tenantId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/roles', {
            params: { tenantId: tenantId }
        });
    }

    public async getTenantRole(tenantId: string, roleId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/role', {
            params: { tenantId: tenantId, roleId: roleId }
        });
    }

    public async createTenantRole(tenantId: string, role: any): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/create-role?tenantId=${tenantId}`, role);
    }

    public async updateTenantRole(tenantId: string, role: any): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/update-role?tenantId=${tenantId}`, role);
    }

    public async deleteTenantRole(tenantId: string, roleId: string): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/delete-role?tenantId=${tenantId}`, {
            roleId: roleId
        });
    }

    public async getTenantUserPermissionMetas(): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/permission/metas');
    }

    public async getTenantRolePermissions(tenantId: string, roleId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/role-permissions', {
            params: { tenantId: tenantId, roleId: roleId }
        });
    }

    public async setTenantUserRoles(tenantId: string, userId: string, roleIds: string[]): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/set-user-roles?tenantId=${tenantId}`, {
            userId: userId,
            roleIds: roleIds
        });
    }

    public async setTenantRolePermissions(tenantId: string, roleId: string, permissions: string[]): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/set-role-permissions?tenantId=${tenantId}`, {
            roleId: roleId,
            permissionCodePaths: permissions
        });
    }
}

export default TenantUserApi;

